import {Section} from "./Section";
import {Card, Space, Tag, Typography} from "antd";
import {resolve} from "@q4us-sw/q4us-ui/lib/Cell";
import React from "react";


export const Stores = ({data,fetchConfig})=>{
    return <Section
        title={"Stores"}
        data={data}
        schema={"reg_approval_store"}
        fetchConfig={async ()=>{
            return await fetchConfig({schema: "reg_approval_store"})
        }}
        resolve={(props)=>{
            switch (props.name){
                case "em_site":
                    return (data.self_reg_site || []).map((o,i)=>{
                        return <Card title={`#${i}`} style={{width: 500}}>
                            <tr className={"section-item"} >
                                <td style={{textAlign: 'right', paddingRight: 20}}>
                                    <Typography.Text>Web Address</Typography.Text>
                                </td>
                                <td style={{textAlign: 'left',paddingLeft: 20}}>
                                    <Typography.Text>
                                        {o.web_address}
                                    </Typography.Text>
                                </td>
                            </tr>
                            <tr className={"section-item"}>
                                <td style={{textAlign: 'right', paddingRight: 20}}>
                                    <Typography.Text>Description</Typography.Text>
                                </td>
                                <td style={{textAlign: 'left',paddingLeft: 20}}>
                                    <Typography.Text>
                                        {o.description}
                                    </Typography.Text>
                                </td>
                            </tr>
                            <tr className={"section-item"}>
                                <td style={{textAlign: 'right', paddingRight: 20}}>
                                    <Typography.Text>Type</Typography.Text>
                                </td>
                                <td style={{textAlign: 'left',paddingLeft: 20}}>
                                    <Typography.Text>
                                    {(o.site_platform || "").toUpperCase()}
                                    </Typography.Text>
                                </td>
                            </tr>
                        </Card>
                    });
                default:
                    return <Tag className={'section-value'}>{resolve(props)}</Tag>
            }
        }}
    />
}
